import axios from "axios";
import Cart from "./cart";
import Common from "./common";
import Config from "./config";
import Core from "./core";
import * as DPErrors from "./errors";
import Payment from "./payment";
import Restaurant from "./restaurant";
import User from "./user";
import Times from "./times";
import Waitlist from "./waitlist";
import Check from "./check";
import Curbside from "./curbside";
import Menu from "./menu";
import Location from "./location";
import Confirmation from "./confirmation";
import DineInOrder from "./dinein";
import Delivery from "./delivery";
import Reservation from "./reservation";
import PrivateDining from "./privateDining";
import WineList from "./winelist";
import WineLocker from "./winelocker";
import JoinEClub from "./joineclub";
export * from "./types";

function isNodejs() {
  return typeof process === "object" && typeof process.versions === "object" && typeof process.versions.node !== "undefined";
}

function createInstance() {
  var axiosInstance = axios.create();
  var config = new Config();
  var core = new Core(config, axiosInstance);
  var user = new User(config, axiosInstance);
  var waitlist = new Waitlist(config, axiosInstance);
  var cart = new Cart(config, axiosInstance);
  var payment = new Payment(config, axiosInstance);
  var common = new Common(config, axiosInstance, cart);
  var restaurant = new Restaurant(config, axiosInstance, common);
  var times = new Times(config, axiosInstance);
  var check = new Check(config, axiosInstance);
  var menu = new Menu(config, axiosInstance);
  var location = new Location(config, axiosInstance);
  var curbside = new Curbside(config, axiosInstance);
  var confirmation = new Confirmation(config, axiosInstance);
  var dineInOrder = new DineInOrder(config, axiosInstance);
  var reservation = new Reservation(config, axiosInstance);
  var privateDining = new PrivateDining(config, axiosInstance);
  var wineList = new WineList(config, axiosInstance);
  var wineLocker = new WineLocker(config, axiosInstance);
  var joinEClub = new JoinEClub(config, axiosInstance);
  var delivery = new Delivery(config, axiosInstance);
  return {
    Config: config,
    Core: core,
    Errors: DPErrors,
    Restaurant: restaurant,
    User: user,
    Waitlist: waitlist,
    Cart: cart,
    Payment: payment,
    Common: common,
    create: null,
    Times: times,
    Check: check,
    Menu: menu,
    Location: location,
    Curbside: curbside,
    Confirmation: confirmation,
    DineInOrder: dineInOrder,
    Reservation: reservation,
    PrivateDining: privateDining,
    WineList: wineList,
    WineLocker: wineLocker,
    JoinEClub: joinEClub,
    Delivery: delivery
  };
}

var dpservices = createInstance();

if (isNodejs()) {
  dpservices.create = createInstance;
}

export default dpservices;